import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import {PureComputed, Subscribable, SubscribableOrNullableValue} from 'knockout';
import tagsParser from 'managers/tagsParser';
import SurveyStatisticsQuestion from 'models/statistics/survey/questions/question';
import SurveyQuestion from 'models/survey/question';
import SurveyStatisticsQuestionSectionsFactory from './factories/questionSections';
import SurveyStatisticsQuestionSection from './models/questionSection';
import './question.html';
import './question.scss';

const sectionsFactory = SurveyStatisticsQuestionSectionsFactory.instance;

export interface SurveyStatisticsQuestionVMConfig {
    surveyQuestion: SubscribableOrNullableValue<SurveyQuestion>
    surveyStatQuestion: SubscribableOrNullableValue<SurveyStatisticsQuestion>
}

@injectable()
export default class SurveyStatisticsQuestionVM {
    labels = labels;

    title: Subscribable<string | undefined>
    descriptionForStatistics: Subscribable<string | undefined>
    statisticsTitle: PureComputed<string | undefined>
    
    averageScore: Subscribable<number | undefined>

    hasAverageScore: Subscribable<boolean>

    sections: Subscribable<Array<SurveyStatisticsQuestionSection>>

    constructor(
        @inject(wccModules.componentConfig) config: SurveyStatisticsQuestionVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const surveyQuestion = ko.flattenComputed(config.surveyQuestion);
        const surveyStatQuestion = ko.flattenComputed(config.surveyStatQuestion);

        this.title = surveyQuestion.pluck(q => q.title).mapNotNull(title => tagsParser.processCustomTags(title, []));
        this.descriptionForStatistics = surveyStatQuestion.pluck(q => q.descriptionForStatistics).mapNotNull(title => tagsParser.processCustomTags(title, []));
        this.statisticsTitle = ko.pureComputed(() => this.descriptionForStatistics() || this.title());
        
        this.averageScore = surveyStatQuestion.pluck(sq => sq.averageScore);

        this.hasAverageScore = this.averageScore.isNotNull();

        const sections = ko.strictComputed((surveyQuestion, surveyStatQuestion) => {
            if (surveyQuestion != undefined && surveyStatQuestion != undefined)
                return sectionsFactory.buildSections(surveyQuestion, surveyStatQuestion);

            return [];
        }, [surveyQuestion, surveyStatQuestion]);

        this.sections = sections.filter(s => !s.isHidden());

        ko.applyBindingsToNode(info.element, {
            'css': {
                'survey-statistics__question': true
            }
        });
    }
}